import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import theme from '../theme';
import Tab from './Tabs/Tab'
import { Alert, Snackbar } from '@mui/material';

export default function FormDialog(props) {
  const [handlerSnack, setHandlerSnack] = React.useState(false)
  const [ msgSnack, setMsgSnack ] = React.useState('')
  const [ sevSnack, setSevSnack ] = React.useState('')

  function showNotify (msg,sev="success"){
    setMsgSnack(msg)
    setSevSnack(sev)
    setHandlerSnack(true)
  }

  const codEmpresa = props.cod_empresa || props.codEmpresa

  return (
    <>
    <Snack open={handlerSnack} message={msgSnack} severity={sevSnack} handlerSnack={() => setHandlerSnack(false)} />
      <Dialog open={props.open} fullWidth={true}
          maxWidth={"auto"}>

          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            {`Empresa: ${codEmpresa || ''}`}
          </DialogTitle>
          <DialogContent>
            <Tab {...props} codEmpresa={codEmpresa} showNotify={showNotify} />
          </DialogContent>
          <DialogActions>
            <Button sx={{ color: theme.palette.text.primary }} onClick={props.handlerClose}>Fechar</Button>
          </DialogActions>
      </Dialog>
    </>
  );
}

const Snack = (props)=>{
  return  (
    <Snackbar
    open={props.open}
    autoHideDuration={6000}
    onClose={() => {props.handlerSnack()}}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    >
     <Alert  onClose={() => {props.handlerSnack()}} severity={props.severity ? props.severity : 'error'} sx={{ width: '100%' }}>
    {props.message}
  </Alert>
  </Snackbar>
  )
}
